var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadOutlined = function SvgLoadOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33154 14.4831C7.53419 14.6001 7.76406 14.6617 7.99805 14.6617C8.23204 14.6617 8.46191 14.6001 8.66455 14.4831L13.3301 11.8171C13.5325 11.7002 13.7007 11.5322 13.8177 11.3298C13.9346 11.1274 13.9963 10.8978 13.9966 10.664V5.33201C13.9963 5.09825 13.9346 4.86866 13.8177 4.66628C13.7007 4.4639 13.5325 4.29584 13.3301 4.17896L8.66455 1.51294C8.46191 1.39594 8.23204 1.33435 7.99805 1.33435C7.76406 1.33435 7.53419 1.39594 7.33154 1.51294L2.66602 4.17896C2.46357 4.29584 2.29543 4.4639 2.17844 4.66628C2.06146 4.86866 1.99975 5.09825 1.99951 5.33201V10.664C1.99975 10.8978 2.06146 11.1274 2.17844 11.3298C2.29543 11.5322 2.46357 11.7002 2.66602 11.8171L7.33154 14.4831Z",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 14.6631V7.99805",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19281 4.66553L7.99806 7.99805L13.8033 4.66553",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99878 2.84595L10.9973 6.27844",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLoadOutlined;